[
    {
        "Select": {
            "editable": false,
            "pinned": "left",
            "refData": {
                "datatype": "checkbox",
                "selectAll": true,
                "colSize": 50
            },
            "maxWidth": 50,
            "rowGroup": false,
            "hide": false,
            "suppressAutoSize": true
        },
        "Div ID": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false,
                "custom_field": "lvl6_from_bottom"
            },
            "rowGroup": false,
            "hide": false
        },
        "Div Name": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false,
                "optionalInput": true,
                "custom_field": "lvl6_from_bottom_name"
            },
            "rowGroup": false,
            "hide": false
        },
        "Dept ID": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false,
                "custom_field": "lvl5_from_bottom"
            },
            "rowGroup": false,
            "hide": false
        },
        "Dept Name": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false,
                "optionalInput": true,
                "custom_field": "lvl5_from_bottom_name"
            },
            "rowGroup": false,
            "hide": false
        },
        "Class ID": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false,
                "custom_field": "lvl4_from_bottom"
            },
            "rowGroup": false,
            "hide": false
        },
        "Class Name": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false,
                "optionalInput": true,
                "custom_field": "lvl4_from_bottom_name"
            },
            "rowGroup": false,
            "hide": false
        },
        "Style ID": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Sty Name": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Styc ID": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Styc Name": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Color Family": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Attr 1": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Value 1": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Attr 2": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Value 2": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Attr 3": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Value 3": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Retail Cost ($)": {
            "editable": false,
            "aggFunc": "sum",
            "refData": {
                "datatype": "currency",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Retail Price ($)": {
            "editable": false,
            "aggFunc": "sum",
            "refData": {
                "datatype": "currency",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Ecomm Size Range": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Stores Size Range": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Store Distro": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "MOQ": {
            "editable": true,
            "cellDataType": "number",
            "aggFunc": "sum",
            "refData": {
                "datatype": "number",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Ecomm Tgt Qty": {
            "editable": true,
            "cellDataType": "number",
            "aggFunc": "sum",
            "refData": {
                "datatype": "number",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Stores Tgt Qty": {
            "editable": true,
            "cellDataType": "number",
            "aggFunc": "sum",
            "refData": {
                "datatype": "number",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Total Tgt Qty": {
            "editable": false,
            "aggFunc": "sum",
            "refData": {
                "datatype": "number",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Ecomm Demand Qty": {
            "editable": false,
            "cellDataType": "number",
            "aggFunc": "sum",
            "refData": {
                "datatype": "number",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Stores Demand Qty": {
            "editable": false,
            "cellDataType": "number",
            "aggFunc": "sum",
            "refData": {
                "datatype": "number",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Total Demand Qty": {
            "editable": false,
            "aggFunc": "sum",
            "refData": {
                "datatype": "number",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Ecomm Reco Qty": {
            "editable": true,
            "cellDataType": "number",
            "aggFunc": "sum",
            "refData": {
                "datatype": "number",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Stores Reco Qty": {
            "editable": true,
            "cellDataType": "number",
            "aggFunc": "sum",
            "refData": {
                "datatype": "number",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Total Reco Qty": {
            "editable": false,
            "aggFunc": "sum",
            "refData": {
                "datatype": "number",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Ecomm Reco Cost ($)": {
            "editable": false,
            "aggFunc": "sum",
            "refData": {
                "datatype": "currency",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Stores Reco Cost ($)": {
            "editable": false,
            "aggFunc": "sum",
            "refData": {
                "datatype": "currency",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Total Reco Cost ($)": {
            "editable": false,
            "aggFunc": "sum",
            "refData": {
                "datatype": "currency",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Ecomm Reco Price ($)": {
            "editable": false,
            "aggFunc": "sum",
            "refData": {
                "datatype": "currency",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Stores Reco Price ($)": {
            "editable": false,
            "aggFunc": "sum",
            "refData": {
                "datatype": "currency",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Total Reco Price ($)": {
            "editable": false,
            "aggFunc": "sum",
            "refData": {
                "datatype": "currency",
                "showToolTip": false,
                "optionalInput": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Status": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            }
        },
        "Locked": {
            "editable": false,
            "pinned": false,
            "refData": {
                "datatype": "icon-button|lock",
                "_confirm_action": false,
                "displayBlankHeader": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Delete": {
            "editable": false,
            "pinned": "right",
            "refData": {
                "datatype": "action-button|delete",
                "_confirm_action": false,
                "displayBlankHeader": true
            },
            "rowGroup": false,
            "hide": false
        }
    }
]
